// extracted by mini-css-extract-plugin
export var card = "_8d-1";
export var container = "_8d-0";